import React from 'react'
import { createComponent } from '@ycos/fela'
import { BackgroundPicture } from '@ycos/picture'
import { fullBleedStyles } from '@ycos/layout-fullbleed'

// Because the hero image sometimes spans the full width (100vw), we need to ensure that imageSphere has a width that covers both mobile and full-view width on desktop.
const HERO_IMAGES_IMAGE_SPHERE_WIDTHS = [800, 1500, 3000]

const Container = createComponent('Container', (props) => {
  const { stickyText, theme, isLoyaltyHeader, isNewLoyaltyHeader } = props
  const isFullBleed = theme.fullBleed || isLoyaltyHeader || isNewLoyaltyHeader

  return {
    position: 'relative',
    maxWidth: isFullBleed ? 'auto' : theme.breakpoints.xlarge.width,
    margin: isFullBleed ? 0 : '0 auto',
    '@media(min-width: 960px)': {
      marginTop: isFullBleed ? 0 : `${2 * theme.spacingMultiplier}px`
    },
    marginBottom: stickyText ? '-100px' : undefined,
    'screen-medium-max': {
      marginBottom: stickyText ? '-120px' : undefined
    },
    zIndex: stickyText ? '0' : undefined,
    transform: 'rotateZ(0deg)',
    ...(isLoyaltyHeader || isNewLoyaltyHeader ? fullBleedStyles : {})
  }
})

const StyledBlock = createComponent('styledBlock', (props) => ({
  display: 'block',
  position: 'absolute',
  bottom: props.stickyText ? 0 : props.bottom,
  top: props.stickyText ? 0 : undefined,
  left: 0,
  right: 0,
  zIndex: '1'
}))

const StickyTextCover = createComponent('stickyTextCover', () => ({
  display: 'block',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'white',
  height: '100px',
  'screen-medium-max': {
    height: '120px'
  },
  zIndex: '2'
}))

const XlDesktopLayout = createComponent('LayoutWrapper', () => ({
  display: 'none',
  'screen-xlarge': {
    display: 'block'
  }
}))

const DesktopLayout = createComponent('LayoutWrapper', () => ({
  display: 'none',
  'screen-medium': {
    display: 'block'
  },
  'screen-xlarge': {
    display: 'none'
  }
}))

const MobileLayout = createComponent('LayoutWrapper', () => ({
  display: 'block',
  'screen-medium': {
    display: 'none'
  }
}))

export const Hero = ({
  pictures = [],
  config = {},
  opacity,
  foreground,
  verticalAlignment,
  mobileHeight,
  desktopHeight,
  xlDesktopHeight,
  desktopBottomPadding,
  mobileBottomPadding,
  isTitleBanner,
  imageProps,
  isLoyaltyHeader,
  isNewLoyaltyHeader
}) => {
  const xlHeight = xlDesktopHeight || desktopHeight
  const backgroundPicture = (height, bottom) => {
    const width = isTitleBanner ? '100vw' : '100%'
    return (
      <BackgroundPicture
        images={pictures}
        imagesphere={config.imageSphere}
        opacity={opacity}
        width={width}
        height={height}
        verticalAlignment={verticalAlignment}
        widths={HERO_IMAGES_IMAGE_SPHERE_WIDTHS}
        stickyText={isTitleBanner}
        {...imageProps}
      >
        <StyledBlock bottom={bottom} stickyText={isTitleBanner}>
          {foreground}
        </StyledBlock>
        {isTitleBanner && <StickyTextCover stickyText={isTitleBanner} />}
      </BackgroundPicture>
    )
  }
  return (
    <Container isLoyaltyHeader={isLoyaltyHeader} isNewLoyaltyHeader={isNewLoyaltyHeader} stickyText={isTitleBanner}>
      <XlDesktopLayout data-automation="hero-banner">{backgroundPicture(xlHeight, desktopBottomPadding)}</XlDesktopLayout>
      <DesktopLayout data-automation="hero-banner">{backgroundPicture(desktopHeight, desktopBottomPadding)}</DesktopLayout>
      <MobileLayout>{backgroundPicture(mobileHeight, mobileBottomPadding)}</MobileLayout>
    </Container>
  )
}
